export default __webpack_public_path__ + "static/media/sm_fox.7157821f.gif";